


































import Vue from "vue";
import Paginate from "vuejs-paginate";
import LatestNews from "@/components/organisms/LatestNews.vue";
import SiteFooter from "@/components/organisms/Footer.vue";
import Loading from "@/components/atoms/Loading.vue";
import { showNotifyDialog } from "@/lib/dialog";
import axiosBase from "axios";

const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY }
});

export default Vue.extend({
  el: ".news",
  components: {
    LatestNews,
    SiteFooter,
    Loading,
    Paginate
  },
  data() {
    return {
      news: null,
      limit: 15,
      currentPage: 1,
      totalCount: 0
    };
  },
  methods: {
    clickCallback(pageNum) {
      this.currentPage = Number(pageNum);
      this.getNews;
      window.scrollTo(0, 0);
    }
  },
  computed: {
    async getNews() {
      const newsRequest = await axios.get(
        `/news?limit=${this.limit}&offset=${(this.currentPage - 1) *
          this.limit}`
      );
      if (newsRequest.status !== 200) {
        await showNotifyDialog({
          title: "エラー",
          content: "お知らせの取得に失敗しました。"
        });
      }
      this.news = newsRequest.data.contents;
      this.totalCount = newsRequest.data.totalCount;
      return this.news;
    },
    getPageCount() {
      return Math.ceil(this.totalCount / this.limit);
    }
  },
  created() {
    this.getNews;
  }
});
